import React from "react";

const Icon_5 = () => {
  return (
    <>
      <svg
        width="216"
        height="156"
        viewBox="0 0 216 156"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3225_23830)">
          <path
            d="M100.371 23.2357C100.371 22.9121 100.862 22.6499 101.466 22.6499H118.524C119.128 22.6499 119.619 22.9121 119.619 23.2357V141.253H100.371V23.2357Z"
            fill="url(#paint0_linear_3225_23830)"
          />
          <path
            d="M9.48047 50.231C9.48047 49.8027 9.98748 49.4549 10.6121 49.4549H28.2437C28.8683 49.4549 29.3753 49.8027 29.3753 50.231V141.253H9.48047V50.231ZM131.261 39.0664C131.261 38.6381 131.768 38.2903 132.392 38.2903H150.024C150.649 38.2903 151.156 38.6381 151.156 39.0664V141.253H131.261V39.0664ZM39.6241 8.46719C39.6241 8.0388 40.1312 7.69104 40.7557 7.69104H58.3874C59.0119 7.69104 59.519 8.03838 59.519 8.46719V141.253H39.6241V8.46719ZM162.007 8.46719C162.007 8.0388 162.514 7.69104 163.139 7.69104H180.771C181.395 7.69104 181.902 8.03838 181.902 8.46719V141.253H162.007V8.46719ZM70.3707 61.8091C70.3707 61.3808 70.8777 61.033 71.5023 61.033H89.1339C89.7585 61.033 90.2655 61.3808 90.2655 61.8091V141.253H70.3707V61.8091ZM192.151 61.8091C192.151 61.3808 192.658 61.033 193.283 61.033H211.517C212.142 61.033 212.649 61.3808 212.649 61.8091V141.253H192.151V61.8091Z"
            fill="url(#paint1_linear_3225_23830)"
          />
          <path
            d="M9.74023 98.8066L11.8515 95.0149C14.1037 91.2231 18.4676 83.6396 22.6905 72.2644C27.0543 60.8892 31.4178 45.7222 35.7816 43.8263C40.0045 41.9304 44.368 53.3057 48.7318 53.3057C53.0953 53.3057 57.3182 41.9304 61.682 36.2428C66.0455 30.5552 70.409 30.5552 74.7728 43.8263C78.9957 57.0974 79.697 86.0095 87.7231 79.8479C92.0869 76.0561 96.3094 41.9304 100.673 36.2428C105.037 30.5552 109.401 53.3057 113.623 55.2015C117.987 57.0974 122.351 38.1387 126.715 41.9304C131.078 45.7222 135.301 72.2644 139.665 81.7438C144.028 91.2231 148.392 83.6396 152.615 74.1603C156.979 64.6809 157.063 65.6288 161.427 58.0453C165.65 50.4619 170.013 46.6701 172.266 44.7742L174.377 42.8784"
            stroke="#425D66"
            strokeWidth="2"
          />
          <mask
            id="mask0_3225_23830"
            style={{maskType:"luminance"}}
            maskUnits="userSpaceOnUse"
            x="111"
            y="61"
            width="95"
            height="94"
          >
            <path
              d="M205.103 61.6122H111.75V154.346H205.103V61.6122Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_3225_23830)">
            <path
              d="M141.649 67.1378H147.158C160.616 67.1378 171.525 77.9752 171.525 91.3438V96.8164C171.525 110.185 160.616 121.022 147.158 121.022H141.649C128.191 121.022 117.281 110.185 117.281 96.8164V91.3438C117.281 77.9752 128.191 67.1378 141.649 67.1378Z"
              fill="#18242F"
            />
            <path
              d="M156.456 94.2407C157.101 94.2408 157.721 94.4957 158.177 94.9493C158.634 95.4029 158.89 96.018 158.89 96.6594V104.398C158.878 105.031 158.616 105.634 158.16 106.078C157.705 106.521 157.093 106.769 156.456 106.769C155.818 106.769 155.206 106.521 154.751 106.078C154.296 105.634 154.034 105.031 154.021 104.398V96.6594C154.021 96.3418 154.084 96.0273 154.207 95.7338C154.329 95.4404 154.508 95.1738 154.734 94.9492C154.96 94.7246 155.229 94.5464 155.524 94.4248C155.82 94.3033 156.136 94.2407 156.456 94.2407Z"
              fill="#425D66"
            />
            <path
              d="M148.417 86.1802C149.062 86.1802 149.682 86.4349 150.138 86.8884C150.595 87.3419 150.851 87.957 150.852 88.5984V104.398C150.843 105.034 150.582 105.64 150.127 106.087C149.671 106.533 149.057 106.783 148.417 106.783C147.777 106.783 147.163 106.533 146.707 106.087C146.252 105.64 145.991 105.034 145.982 104.398V88.5984C145.982 87.957 146.239 87.3419 146.695 86.8884C147.152 86.4349 147.771 86.1802 148.417 86.1802Z"
              fill="#425D66"
            />
            <path
              d="M140.38 89.4042C141.025 89.4043 141.644 89.6591 142.101 90.1126C142.557 90.566 142.814 91.1811 142.814 91.8224V104.398C142.814 105.04 142.558 105.655 142.101 106.108C141.644 106.562 141.025 106.816 140.38 106.816C139.734 106.816 139.115 106.562 138.658 106.108C138.202 105.655 137.945 105.04 137.945 104.398V91.8224C137.945 91.5048 138.008 91.1903 138.13 90.8969C138.253 90.6035 138.432 90.3369 138.658 90.1123C138.884 89.8877 139.153 89.7096 139.448 89.5881C139.743 89.4666 140.06 89.4041 140.38 89.4042Z"
              fill="#425D66"
            />
            <path
              d="M132.348 81.3434C132.994 81.3435 133.613 81.5983 134.07 82.0518C134.526 82.5053 134.783 83.1203 134.783 83.7616V104.398C134.77 105.031 134.508 105.634 134.053 106.078C133.598 106.521 132.986 106.769 132.348 106.769C131.711 106.769 131.099 106.521 130.644 106.078C130.189 105.634 129.927 105.031 129.914 104.398V83.7616C129.914 83.1202 130.171 82.5052 130.627 82.0517C131.084 81.5982 131.703 81.3434 132.348 81.3434Z"
              fill="#425D66"
            />
            <path
              d="M121.316 71.1138C127.484 64.9871 135.685 61.6122 144.408 61.6122C153.132 61.6122 161.332 64.9871 167.501 71.1138C173.67 77.2415 177.066 85.3885 177.066 94.054C177.066 101.808 174.346 109.146 169.356 114.993L175.956 121.55C179.341 119.817 183.614 120.36 186.447 123.175L202.468 139.089C203.306 139.917 203.97 140.902 204.423 141.987C204.875 143.072 205.106 144.235 205.103 145.409C205.106 146.583 204.875 147.746 204.423 148.831C203.97 149.915 203.306 150.9 202.468 151.728C201.633 152.558 200.641 153.217 199.549 153.665C198.458 154.114 197.288 154.344 196.106 154.342C194.925 154.344 193.755 154.114 192.663 153.665C191.571 153.217 190.579 152.558 189.744 151.728L173.724 135.814C172.886 134.986 172.221 134.001 171.769 132.916C171.316 131.832 171.085 130.669 171.089 129.494C171.089 128.043 171.435 126.644 172.088 125.392L165.488 118.835C159.6 123.793 152.213 126.495 144.408 126.495C135.685 126.495 127.483 123.12 121.316 116.993C115.147 110.866 111.75 102.72 111.75 94.0535C111.75 85.3885 115.147 77.2415 121.316 71.1138ZM125.184 113.151C130.319 118.252 137.146 121.062 144.408 121.062C151.671 121.062 158.498 118.252 163.633 113.151C168.768 108.05 171.596 101.268 171.596 94.054C171.596 86.8396 168.768 80.0577 163.633 74.9562C158.498 69.8551 151.671 67.046 144.408 67.046C137.146 67.046 130.319 69.8551 125.184 74.9562C120.048 80.0577 117.22 86.8396 117.22 94.0535C117.22 101.268 120.048 108.05 125.184 113.151Z"
              fill="#6EB0A9"
            />
          </g>
          <path
            d="M109.907 42.443C109.907 41.4627 109.108 40.6681 108.121 40.6681C107.134 40.6681 106.334 41.4627 106.334 42.443C106.334 43.4232 107.134 44.2179 108.121 44.2179C109.108 44.2179 109.907 43.4232 109.907 42.443Z"
            fill="#6DAEA8"
          />
          <path
            d="M110.801 42.443C110.801 40.9727 109.601 39.7809 108.121 39.7809C106.641 39.7809 105.441 40.9727 105.441 42.443C105.441 43.9132 106.641 45.1051 108.121 45.1051C109.601 45.1051 110.801 43.9132 110.801 42.443Z"
            stroke="#6DAEA8"
            strokeOpacity="0.25"
            strokeWidth="3.755"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_3225_23830"
            x1="109.995"
            y1="22.6499"
            x2="109.995"
            y2="141.253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#344250" />
            <stop offset="0.895888" stopColor="#050E19" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3225_23830"
            x1="111.065"
            y1="7.69104"
            x2="111.065"
            y2="141.253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1A2933" />
            <stop offset="0.912984" stopColor="#040E18" />
          </linearGradient>
          <clipPath id="clip0_3225_23830">
            <rect width="216" height="156" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default Icon_5;
